import axios from "axios";
import { Children, createContext, useContext, useEffect, useState } from "react";
import { BASE_URL } from "../config/config";

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
	const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([])
  const getAllProducts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/getallproducts`);
	  setProducts(response.data.data)
    } catch (error) {
      console.log(error);
    }
  };

  const getAllCategories = async()=>{
    try {
      const response = await axios.get(`${BASE_URL}/all_categories`)
      setCategories(response.data.data)
  
    } catch (error) {
      console.log(error)
    }
  }

useEffect(()=>{
	getAllProducts()
  getAllCategories()
},[])

  return <ProductContext.Provider value={{products,categories}}>{children}</ProductContext.Provider>;
};
export const useProducts = () => useContext(ProductContext);
